// Constantes y helpers de SEO compartidos por las páginas públicas.
//
// La URL base se resuelve desde NEXT_PUBLIC_APP_URL (misma convención que el
// resto de la app, ver dashboard/_lib/survey-links.js) y cae a producción por
// defecto. `metadataBase` en el layout raíz usa este valor, de modo que las
// URLs canónicas relativas de cada página se resuelven a absolutas.

export const SITE_NAME = "Kaizen Feedback";

export const SITE_URL = (
  process.env.NEXT_PUBLIC_APP_URL || "https://kaizenfeedback.com"
).replace(/\/$/, "");

/**
 * Construye el objeto `metadata` de una página pública con canonical, Open
 * Graph y Twitter coherentes. La imagen OG NO se define aquí: la aporta el
 * fichero `app/opengraph-image.js` (convención file-based de Next), que Next
 * añade automáticamente a `openGraph.images`/`twitter.images` de toda la ruta.
 *
 * @param {object} opts
 * @param {string} [opts.title]       Título de la página (se le aplica el template del layout).
 * @param {string} [opts.description] Meta description.
 * @param {string} [opts.path]        Ruta relativa para el canonical (p. ej. "/planes").
 * @param {string} [opts.fullTitle]   Título completo para OG/Twitter (usa la home el título por defecto).
 */
export function buildMetadata({
  title,
  description,
  path = "/",
  fullTitle,
} = {}) {
  const ogTitle = fullTitle ?? (title ? `${title} — ${SITE_NAME}` : SITE_NAME);

  return {
    ...(title ? { title } : {}),
    ...(description ? { description } : {}),
    alternates: { canonical: path },
    openGraph: {
      title: ogTitle,
      ...(description ? { description } : {}),
      url: path,
      type: "website",
    },
    twitter: {
      title: ogTitle,
      ...(description ? { description } : {}),
    },
  };
}
